export default () => ({

    video: null,
    /**
         * Init player
         * 
         * Start playing the video and pause it as soon as it is playing
         */
    init() {

        let source = this.$refs.source.dataset.src;
        source = source.replace('?dnt=0&', '?')
        source = source.replace('?dnt=1&', '?')
        this.$root.src = source
        this.video = this.$root
    },

    /**
         * Start playing the video when it's the current slide.
         * From playIfVideo in slider_helpers.js
         */
    onSlideIsVideo() {
        console.log('mm.')
        //this.$root.play()
    },

    /**
         * Loaded Data Event from media element 
         * https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/loadeddata_event 
         * 
         */
    onLoadedData() {
        //console.log('%c%s', 'color: #0088cc', 'onLoadedData');
    },

    /**
         * Play Event
         * https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play_event
         * @param {*} e 
         */
    onPlay(e) {
        this.video.play()
    },


    onPause() {
        // console.log('onpause')

        // this.video.pause()

    },

    /**
         * Pause event from slider helper
         */
    onSliderPauseVideo() {
        // this.$el.pause();
    },
    onSliderVideoClick(){
        const icon = this.$root.previousElementSibling;
        
        
        if(this.$el.muted){
            this.$el.muted=false
            icon.style.display="none"
            return;
        } 
        icon.style.display="block"

        this.$el.muted=true
    }


});